var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgApple(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_11862_133233)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.8104 11.1193C18.8005 9.39524 19.6287 8.094 21.3051 7.13568C20.3671 5.87202 18.9501 5.17678 17.0792 5.04055C15.308 4.90901 13.3722 6.01295 12.6637 6.01295C11.9153 6.01295 10.1991 5.08752 8.85197 5.08752C6.06798 5.1298 3.10938 7.17796 3.10938 11.3447C3.10938 12.5755 3.34886 13.847 3.82782 15.1592C4.46644 16.8832 6.77146 21.1111 9.17626 21.0406C10.4335 21.0124 11.3216 20.1998 12.9581 20.1998C14.5447 20.1998 15.3679 21.0406 16.7699 21.0406C19.1946 21.0078 21.2801 17.1651 21.8888 15.4364C18.6358 13.9942 18.8104 11.2085 18.8104 11.1193V11.1193ZM15.9865 3.40577C17.3486 1.88375 17.2239 0.497948 17.184 0C15.9816 0.0657667 14.5896 0.77041 13.7963 1.63947C12.9232 2.5696 12.4093 3.72051 12.519 5.01706C13.8212 5.11101 15.0087 4.48153 15.9865 3.40577V3.40577Z",
    fill: "#242426"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_11862_133233"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 21.1111,
    fill: "white",
    transform: "translate(2.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApple);
export default __webpack_public_path__ + "static/media/apple.4572515753a3ad35112ed33d591ee6cf.svg";
export { ForwardRef as ReactComponent };